import { render } from "./employee-modal.vue?vue&type=template&id=cd38b818"
import script from "./employee-modal.vue?vue&type=script&lang=js"
export * from "./employee-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__